import React, { Component } from 'react';
import Modal from './Modal';
import ButtonCustom from './ButtonCustom';
import { Grid } from '@material-ui/core';
import { withStyles, } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import Typo from './CustomTypo'

const styles = theme => ({
    marginTop: {
        marginTop: theme.spacing(6),
    },
    form: { minWidth: 290 },
    icon: {
        width: '80px',
        height: '80px'
    },
    message: {
        textAlign: 'center',
        marginTop: theme.spacing(6),
    }
});

class ModalConfirm extends Component {
    
    onClose(){
        const { onClose, error } = this.props;
        onClose();
    }

    render() {
        const { classes, t } = this.props;
        return (
            <Modal
                maxWidth='xs'
                open={this.props.open}
                onClose={this.onClose}
                hideHeader={true}
                content={
                    <Grid xs={12} container item direction='row' justify="center" >
                        <Grid xs={12} container item direction='row' justify="center" >
                            {this.props.isCustomMessage ? this.props.message :
                                <Typo variant='body2' className={classes.message}>{t(this.props.message)}</Typo>
                            }
                        </Grid>
                    </Grid>
                }
                action={<Grid xs={10} item container direction='row' spacing={3}>
                            <Grid xs={6} item >
                                <ButtonCustom color='secondary' fullWidth
                                    onClick={() => this.onClose()}
                                >{this.props.buttonLabel ? this.props.buttonLabel : (t('Close'))} </ButtonCustom>
                            </Grid>
                            <Grid xs = {6} item>
                                <ButtonCustom color='primary' fullWidth
                                    onClick={() => this.props.onAction()}
                                >{this.props.confirm} </ButtonCustom>
                            </Grid>

                        </Grid>
                }
            >
            </Modal>
        );
    }


}

export default withTranslation()(withStyles(styles)(ModalConfirm));